<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-1"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-1"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-1"/>
                </v-col>
                <v-col>
                    <v-skeleton-loader type="text" class="my-1"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-1"/>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "WarehouseItemLoader"
}
</script>

<style>

</style>